import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';
import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';
import { RequireStaff } from '@features/cms/components/RequireStaff.tsx';

const QuotesPage = lazyWithRetry(() =>
  import('@erp/quotes/pages/QuotesPage.tsx').then((module) => ({
    default: module.QuotesPage ?? module.default,
  })),
);

const PublicQuotePage = lazyWithRetry(() =>
  import('@erp/quotes/pages/PublicQuotePage.tsx').then((module) => ({
    default: module.PublicQuotePage ?? module.default,
  })),
);

const QuotesRoute = () => <RequireStaff render={() => <QuotesPage />} />;

const quotesNode: ComponentPage = {
  component: QuotesRoute,
  handle: { breadcrumb: 'quotes' },
};

const publicQuoteNode: ComponentPage = {
  component: PublicQuotePage,
  handle: { breadcrumb: 'quote' },
};

const quotesRoutes: ComponentOrMapping = {
  erp: {
    quotes: quotesNode,
  },
  q: {
    ':publicId': publicQuoteNode,
  },
  quotes: {
    public: {
      ':publicId': publicQuoteNode,
    },
  },
};

export default quotesRoutes;
